<template>
  <section class="ON_main_article_area ON_single_post_column ON_100px_padding">
    <div class="container">
      <div class="row">
        <img
          class="img-fluid"
          src="../assets/blog_head.jpg"
          alt=""
          height="100"
        />

        <div class="col-lg-8">
          <div
            class="ON_main_article_details"
            v-for="blogEntry in blogEntries"
            :key="blogEntry.id"
          >
            <a href="#"
              ><h4>{{ blogEntry.title }} <br /></h4
            ></a>
            <div class="ON_article_basic_information">
              <div class="float-left">
                <a href="#">Blog Post</a>
              </div>
              <div class="float-right">
                <div class="media">
                  <div class="media-body">
                    <h5>Harvey</h5>
                    <p>{{ blogEntry.date }}</p>
                  </div>
                </div>
              </div>
            </div>
            <p>
              {{ blogEntry.paragraph_one }}
            </p>
            <p>
              {{ blogEntry.paragraph_two }}
            </p>
            <p>
              {{ blogEntry.paragraph_three }}
            </p>
            <p>
              {{ blogEntry.paragraph_four }}
            </p>
            <div class="ON_article_footer">
              <link
                href="https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext"
                rel="stylesheet"
              /><a
                class="bmc-button"
                target="_blank"
                href="https://www.buymeacoffee.com/objectiveNews"
                ><img
                  src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
                  alt="Buy us a coffee"
                /><span style="margin-left:5px;font-size:19px !important;"
                  >Buy us a coffee</span
                ></a
              >
              <div class="ON_article_socials ml-auto">
                <ShareNetwork
                  network="facebook"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  hashtags="ObjectiveNews"
                  quote="Objective-News - We stand in the middle"
                  ><i class="fa fa-facebook"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="twitter"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  hashtags="ObjectiveNews"
                  ><i class="fa fa-twitter"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="reddit"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  hashtags="ObjectiveNews"
                  ><i class="fa fa-reddit"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="email"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  description="Objective News blogs"
                  ><i class="fa fa-envelope"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="linkedin"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  description="Objective News blogs"
                  ><i class="fa fa-linkedin"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  description="Objective News blogs"
                  ><i class="fa fa-whatsapp"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="xing"
                  url="https://objective-news.com/blog"
                  title="ON Blogs"
                  ><i class="fa fa-xing"></i
                ></ShareNetwork>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="ON_right_side_column">
            <aside class="ON_right_items ON_ad_items text-center"></aside>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from "@/fb";

export default {
  data() {
    return {
      blogEntries: []
    };
  },
  created() {
    db.collection("blog")
      .orderBy("order_no", "desc")
      .onSnapshot(res => {
        const changes = res.docChanges();

        changes.forEach(change => {
          if (change.type === "added") {
            this.blogEntries.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        });
      });
    document.title = "ON Blog";
  }
};
</script>
